import { Routes, Route } from 'react-router';
import { ProtectedRoute } from '../components/protected-route';
import { routes } from './routes';

export const AppRoutes = () => (
  <Routes>
    {routes.map(({ path, isProtected, adminRequired, element }) => (
      <Route
        key={path}
        path={path}
        element={isProtected ? <ProtectedRoute adminRequired={adminRequired}>{element}</ProtectedRoute> : element}
      />
    ))}
  </Routes>
);
